module.exports = __webpack_public_path__ + "static/media/anything_else.6469ca5e.svg";